// extracted by mini-css-extract-plugin
export default {"root":"djN__b","groupTitle":"WwXnUp","specList":"ti35X3","specTitle":"czFdVW","specValue":"RN1jhY"};